module.exports = __webpack_public_path__ + "static/media/moment11.eb77526e.webp";